document.addEventListener('DOMContentLoaded', () => {
  const viewer = document.querySelector('.artbook-viewer');
  if (!viewer) return;

  const slides = Array.from(viewer.querySelectorAll('.artbook-viewer__slide'));
  const currentEl = viewer.querySelector('.js-artbook-current');
  const prevBtn = viewer.querySelector('.artbook-viewer__arrow--prev');
  const nextBtn = viewer.querySelector('.artbook-viewer__arrow--next');
  const fullscreenBtn = viewer.querySelector('.artbook-viewer__fullscreen');

  if (!slides.length) return;

  let currentIndex = 0;

  const showSlide = (index) => {
    currentIndex = (index + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === currentIndex);
    });

    if (currentEl) {
      currentEl.textContent = String(currentIndex + 1);
    }
  };

  prevBtn?.addEventListener('click', () => {
    showSlide(currentIndex - 1);
  });

  nextBtn?.addEventListener('click', () => {
    showSlide(currentIndex + 1);
  });

  fullscreenBtn?.addEventListener('click', () => {
    viewer.classList.toggle('is-fullscreen');
    fullscreenBtn.textContent = viewer.classList.contains('is-fullscreen')
      ? 'CLOSE'
      : 'FULLSCREEN';
  });

  document.addEventListener('keydown', (event) => {
    if (!document.body.contains(viewer)) return;

    if (event.key === 'ArrowLeft') {
      showSlide(currentIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      showSlide(currentIndex + 1);
    }

    if (event.key === 'Escape' && viewer.classList.contains('is-fullscreen')) {
      viewer.classList.remove('is-fullscreen');
      fullscreenBtn.textContent = 'FULLSCREEN';
    }
  });

  showSlide(0);
});